/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from 'react'
import { YDivider } from 'irmlib/styles'
import styled from 'styled-components'
import Table from '../../../Controls/Table'
import { getUser } from '../../../../redux/global'
import * as gdeTransactionsLite from '../../../../services/firestore/gdeTransactionsLite'
import moment from 'moment'
import { IconButton } from '../../../../irmlib/src/components/Controls'
import CSVImportIcon from '../../../../icons/svg/csv-import-icon'
import { uiGet } from 'irmlib//http'
import { roundNumber, downloadCSV } from '../../../../irmlib/src/common'
import * as constants from 'irmlib/common/constants'
import { useTranslation } from 'react-i18next'


const BottomPaddedDiv = styled('div')`
  padding-bottom: 20px;
`

const TableContainer = styled(BottomPaddedDiv)`
margin-left: 20px;
margin-right: 20px;
`
const TitleSection = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  font-size: 14px;
`
const MainTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
`

const AllJobsExceptionBoxes = (props) => {
  const { t } = useTranslation()
  const tableRef = useRef(null)
  const { filterData } = props

  useEffect(() => {
  }, [props])

  const dataRet = async (val) => {
    const dataQuery = async (val) => {
      const val3 = []
      const statusList = constants.boxStatus.exception
      const userDistrict = getUser()?.district
      const exceptionBoxesList = await gdeTransactionsLite.getJobsWithExceptionBoxes(statusList, userDistrict)
      exceptionBoxesList.forEach((doc) => {
        pushData(doc, val3)
      })
      return val3
    }
    return await dataQuery(val)
  }

  const handleExportCSV = () => {
    const date = moment().format('YYYY-MM-DD')
    const fileName = `Exception_Report_Data${date}.csv`
    let columns = []
    const dataManager = tableRef?.current?.dataManager
    const { columns: tableColumns = [], sortedData: data = [] } = dataManager
    const columnKeys = {}
    const calculateGrandTotal = {}

    columns = [t('reports.exceptionBox.skpBoxId'),
      t('reports.exceptionBox.jobId'),
      t('reports.exceptionBox.exceptionCode'),
      t('reports.exceptionBox.description'),
      t('reports.exceptionBox.status'),
      t('reports.exceptionBox.dateCreated')]
    
    tableColumns.forEach(col => {
      columnKeys[col.field] = col.title
    })
    const generatedData = []
    data.forEach(val => {
      const colunmData = {}
      // eslint-disable-next-line array-callback-return
      Object.keys(val).map(key => {
        if (key in columnKeys) {
          colunmData[columnKeys[key]] = val[key]
          if (columnKeys[key] in calculateGrandTotal) {
            calculateGrandTotal[columnKeys[key]] = roundNumber(calculateGrandTotal[columnKeys[key]] + val[key])
          } else {
            calculateGrandTotal[columnKeys[key]] = val[key]
          }
        }
      })
      generatedData.push(colunmData)
    })
    downloadCSV(fileName, columns, generatedData)
  }

  const pushData = async (doc, val) => {
    val.push({
      skpBoxId: doc.data().boxId,
      jobId: doc.data().jobId,
      status: doc.data().status,
      status1: doc.data().status,
      dateCreated: doc.data().createdTs ? moment(doc.data().createdTs.seconds, 'X').format('YYYY-MM-DD') : '0000-00-00',
      description: doc.data().description,
      exceptionCode: doc.data().exceptionCode,
      exceptionCode1: doc.data().exceptionCode
    })
  }

  const getPageData = async (page, pageSize) => {
    return await uiGet({ service: () => dataRet(filterData) })
  }

  const columns = [
    {
      title: t('tableColumns.skpBoxId'),
      field: 'skpBoxId',
      editable: 'never',
      headerAlign: 'center',
      hidden: false,
      sortable: true,
      cellStyle: { overflow: 'hidden' },
    },
    {
      title: t('tableColumns.jobId'),
      field: 'jobId',
      editable: 'never',
      headerAlign: 'center',
      sortable: true,
      cellStyle: { overflow: 'hidden' },
      hidden: false
    },
    {
      title: t('tableColumns.exceptionCode'),
      field: 'exceptionCode',
      editable: 'never',
      headerAlign: 'center',
      sortable: true,
      cellStyle: { overflow: 'hidden' },
      hidden: false
    },
    {
      title: t('tableColumns.description'),
      field: 'description',
      editable: 'never',
      headerAlign: 'center',
      sortable: true,
      cellStyle: { overflow: 'hidden' },
      hidden: false
    },
    {
      title: t('tableColumns.status'),
      field: 'status',
      editable: 'never',
      headerAlign: 'center',
      sortable: true,
      cellStyle: { overflow: 'hidden' },
      hidden: false
    },
    {
      title: t('tableColumns.dateCreated'),
      field: 'dateCreated',
      editable: 'never',
      headerAlign: 'center',
      cellStyle: { overflow: 'hidden', whiteSpace: 'nowrap' },
      sortable: true,
      hidden: false,
      render: (rowdata) => (
        <>
          <input
            type='date'
            id={'dateCreated'}
            value={rowdata.dateCreated}
            disabled={true}
            style={{ width: 100 }}
          />
        </>
      )
    },

  ]

  const VerticalDivider = () =>
    <YDivider height='25px' />

  useEffect(() => {
    tableRef.current.dataManager.changeSearchText(props.dataSearch)
    tableRef.current.setState(tableRef.current.dataManager.getRenderState())
  }, [props.dataSearch])

  return (
    <>
      <TitleSection>
        <MainTitle>
          {t('routeTitles.exceptionJobs')}
        </MainTitle>
        <div id='exception_boxes_export'>
          {t('forms.export')}
          <IconButton id={'reports_export'} onClick={handleExportCSV} ><CSVImportIcon /></IconButton>
        </div>
      </TitleSection>
      <TableContainer>
        <VerticalDivider />
        <Table
          title={props}
          tableRef={tableRef}
          columns={columns}
          getPageData={getPageData}
          exportButton={false}
          paging={true}
          draggable={false}
          search={false}
          backgroundColor={'default'}
          sorting={true}
          toolbar={true}
          minWidth='100px'
        />
      </TableContainer>
    </>
  )
}

export default AllJobsExceptionBoxes